define('AlertNoticeView',['underscore', 'backbone', 'jquery',
    'template!blocks/notice/alert-default',
    'template!blocks/notice/alert-sorry',
    'CSS3Events'], function (_, Backbone, $,
                             templateDefault,
                             templateSorry,
                             CSS3Events) {

    //
    // Alert modal view
    //

    return Backbone.View.extend({

        events: {
            'click .overlay, .btn-hide': 'close',
            'keydown': 'keydown',
        }, initialize: function (options) {
            this.render(options);
        },

        render: function (options) {
            var self = this, template;
            if (typeof options == 'string') {
                options = {title: options};
            }
            // TODO factoriser les différents confirm/alert
            function setDefaultOption(key, defaultValue) {
                if (_.isUndefined(options[key])) {
                    options[key] = defaultValue;
                }
            }

            setDefaultOption('title', false);
            setDefaultOption('subtitle', false);
            setDefaultOption('asyncClose', false);
            self.options = options;
            var ok = 'Ok';
            try{
                ok = t(ok, 'UI');
            }catch(err){}
            setDefaultOption('validation', ok);
            //

            // association template
            switch(options.template){
                // template Sorry
                case 'sorry' :
                    template = templateSorry;
                    break;
                // template par défaut
                default:
                    template = templateDefault;
            }

            var html = $(template(options));
            self.setElement(html);
            $('.site').append(html);
            self.show();
            self.$('.btn-hide').focus();
            if(_.isFunction(options.callback)){
                self.on('noticeClose',options.callback);
            }
        },

        keydown:function(e){
            if(e.key === "Escape") {
                e.stopPropagation();
                e.preventDefault();
                this.close(e);
            }
        },

        show: function () {
            var self = this;
            setTimeout(function () {
                self.$el.addClass('active');
            }, 1)
        },

        close: function(){
            var view = this,
                button = view.$('.btn-classic');
            function hide(){
                view.hide();
            }
            this.trigger('noticeClose', true, hide);
            if(!view.options.asyncClose){
                hide();
            }else{
                button.toggleClass('loading');
                button.attr('disabled',true);
            }
        },

        hide: function (e) {
            var self = this;
            self.$el.removeClass('active');
            self.$('.content').one(CSS3Events('transitionend'), function () {
                self.remove();
            });
        }

    });
});
